import React from 'react';
import ReactDOM from 'react-dom';
import { Field,reduxForm } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../components/LoadingSmall.js';
//import { load as loadAccount } from './account'


const validate = values => {
    const errors = {}

    if (!values.firstname) {
        errors.firstname = 'Required'
    }

    if (!values.lastname) {
        errors.lastname = 'Required'
    }

    return errors
}

const renderField = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (

    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type}/>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)



                                    

class UserDetails extends React.Component {
    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-sm-6">
                        <Field component={renderField} type="text" name="firstname" placeholder="John" title="Lastname" className="form-control" />
                    </div>

                    <div className="col-sm-6">
                        <Field component={renderField} type="text" name="lastname" placeholder="Doe" title="Firstname" className="form-control" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        {
                            this.props.isSavingDetails
                            ?
                            <LoadingSmall />
                            :
                            <button type="submit" className="btn btn-dark btn-block">Update</button>
                        }
                    </div>
                </div>

            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({

});


// Decorate the form component
UserDetails = reduxForm({
  form: 'UserDetails',
  validate,
})(UserDetails);

UserDetails = connect(
  state => ({
    initialValues: {
        firstname:state.auth.user.firstname,
        lastname:state.auth.user.lastname,
      }
  })
)(UserDetails)

export default UserDetails;


// WEBPACK FOOTER //
// ./containers/settings/form/UserDetails.js